// extracted by mini-css-extract-plugin
export default {"card":"Contact_card__65bmm","button":"Contact_button__469Rq","cardButtons":"Contact_cardButtons__-rXP3","phoneScreenMargin":"Contact_phoneScreenMargin__MPffQ"};